import pallete from "./pallete";

// Training Type Options
export const TRAINING_TYPES = {
  REGULER: "REG",
  AKSELERASI: "AKS",
  SERTIFIKASI: "SERT",
};

export const TRAINING_TYPE_OPTIONS = [
  { label: "Reguler", value: TRAINING_TYPES.REGULER },
  { label: "Akselerasi", value: TRAINING_TYPES.AKSELERASI },
  { label: "Sertifikasi", value: TRAINING_TYPES.SERTIFIKASI },
];

export const TRAINING_TYPE_LABELS = {
  [TRAINING_TYPES.REGULER]: "Reguler",
  [TRAINING_TYPES.AKSELERASI]: "Akselerasi",
  [TRAINING_TYPES.SERTIFIKASI]: "Sertifikasi",
};

export const TRAINING_TYPE_COLORS = {
  [TRAINING_TYPES.REGULER]: pallete.success.main,
  [TRAINING_TYPES.AKSELERASI]: pallete.blue,
  [TRAINING_TYPES.SERTIFIKASI]: pallete.orange,
};

// Cost Source Options
export const COST_SOURCES = {
  CPMI: "PMI",
  GOVERNMENT: "GOV",
  VOKASI: "EMP",
};

export const TRAINING_CATEGORY = {
  AKS: "AKS",
  SERT: "SERT",
  REG: "REG",
};

export const COST_SOURCE_OPTIONS = [
  { label: "Sumber Pendanaan Lainnya", value: COST_SOURCES.CPMI },
  { label: "Ditanggung APBN", value: COST_SOURCES.GOVERNMENT },
  { label: "Ditanggung APBD", value: COST_SOURCES.VOKASI },
];

export const COST_SOURCE_LABELS = {
  [COST_SOURCES.CPMI]: "Sumber Pendanaan Lainnya",
  [COST_SOURCES.GOVERNMENT]: "Ditanggung APBN",
  [COST_SOURCES.VOKASI]: "Ditanggung APBD",
};

export const TRAINING_CATEGORY_LABELS = {
  [TRAINING_CATEGORY.AKS]: "Akselerasi",
  [TRAINING_CATEGORY.SERT]: "Sertifikasi",
  [TRAINING_CATEGORY.REG]: "Reguler",
};

// Status Options
export const TRAINING_STATUS = {
  PENDING: "Menunggu Verifikasi",
  VERIFIED: "verified",
  ACCEPTED: "Diterima",
  REVISED: "Revisi",
  REJECTED: "Ditolak",
};

export const TRAINING_STATUS_LABELS = {
  [TRAINING_STATUS.PENDING]: "Menunggu Verifikasi",
  [TRAINING_STATUS.VERIFIED]: "Terverifikasi",
  [TRAINING_STATUS.ACCEPTED]: "Diterima",
  [TRAINING_STATUS.REVISED]: "Direvisi",
  [TRAINING_STATUS.REJECTED]: "Ditolak",
  pending: "Menunggu Verifikasi",
  accepted: "Diterima",
  revised: "Direvisi",
  rejected: "Ditolak",
};

export const TRAINING_STATUS_COLORS = {
  [TRAINING_STATUS.PENDING]: "yellow",
  [TRAINING_STATUS.VERIFIED]: "green",
  [TRAINING_STATUS.ACCEPTED]: "green",
  [TRAINING_STATUS.REVISED]: "purple",
  [TRAINING_STATUS.REJECTED]: "red",
  pending: "yellow",
  accepted: "green",
  revised: "purple",
  rejected: "red",
};

// Status filter mapping for each page type
export const STATUS_FILTER_MAP = {
  "Menunggu Verifikasi": TRAINING_STATUS.PENDING,
  accepted: TRAINING_STATUS.ACCEPTED,
  rejected: TRAINING_STATUS.REJECTED,
  revised: TRAINING_STATUS.REVISED,
};

// Modal Messages
export const MODAL_MESSAGES = {
  VERIFY: {
    TITLE: "Konfirmasi Verifikasi",
    DESCRIPTION: "Apakah Anda yakin ingin memverifikasi katalog pelatihan ini?",
    SUCCESS: "Katalog pelatihan berhasil diverifikasi!",
    ERROR: "Gagal memverifikasi katalog pelatihan.",
  },
  REJECT: {
    TITLE: "Konfirmasi Tolak",
    DESCRIPTION: "Apakah Anda yakin ingin menolak katalog pelatihan ini?",
    SUCCESS: "Katalog pelatihan berhasil ditolak.",
    ERROR: "Gagal menolak katalog pelatihan.",
    REASON_REQUIRED: "Harap isi alasan penolakan!",
    REASON_LABEL: "Alasan Tolak",
    REASON_PLACEHOLDER: "Tuliskan alasan penolakan di sini...",
  },
};

// Table Configuration
export const TABLE_CONFIG = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: ["10", "20", "50"],
};
